// state/workspace/workspace.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { WorkspaceState } from '../../models/workspace.model';
import * as WorkspaceActions from './workspace.actions';

export { WorkspaceState } from '../../models/workspace.model';

export const initialState: WorkspaceState = {
  workspaces: [],
  selectedWorkspace: null,
  loading: false,
  error: null
};

export const workspaceReducer = createReducer(
  initialState,

  // Load Workspaces
  on(WorkspaceActions.loadWorkspaces, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(WorkspaceActions.loadWorkspacesSuccess, (state, { workspaces }) => ({
    ...state,
    workspaces,
    loading: false,
    error: null
  })),

  on(WorkspaceActions.loadWorkspacesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Load Single Workspace
  on(WorkspaceActions.loadWorkspaceById, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(WorkspaceActions.loadWorkspaceByIdSuccess, (state, { workspace }) => ({
    ...state,
    selectedWorkspace: workspace,
    loading: false,
    error: null
  })),

  on(WorkspaceActions.loadWorkspaceByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create Workspace
  on(WorkspaceActions.createWorkspace, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(WorkspaceActions.createWorkspaceSuccess, (state, { workspace }) => ({
    ...state,
    workspaces: [...state.workspaces, workspace],
    loading: false,
    error: null
  })),

  on(WorkspaceActions.createWorkspaceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Update Workspace
  on(WorkspaceActions.updateWorkspace, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(WorkspaceActions.updateWorkspaceSuccess, (state, { workspace }) => ({
    ...state,
    workspaces: state.workspaces.map(w =>
      w.id === workspace.id ? workspace : w
    ),
    selectedWorkspace: state.selectedWorkspace?.id === workspace.id
      ? workspace
      : state.selectedWorkspace,
    loading: false,
    error: null
  })),

  on(WorkspaceActions.updateWorkspaceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Delete Workspace
  on(WorkspaceActions.deleteWorkspace, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(WorkspaceActions.deleteWorkspaceSuccess, (state, { id }) => ({
    ...state,
    workspaces: state.workspaces.filter(w => w.id !== id),
    selectedWorkspace: state.selectedWorkspace?.id === id
      ? null
      : state.selectedWorkspace,
    loading: false,
    error: null
  })),

  on(WorkspaceActions.deleteWorkspaceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Select Workspace
  on(WorkspaceActions.selectWorkspace, (state, { workspace }) => ({
    ...state,
    selectedWorkspace: workspace
  })),

  on(WorkspaceActions.clearSelectedWorkspace, state => ({
    ...state,
    selectedWorkspace: null
  })),

  // Clear Error
  on(WorkspaceActions.clearWorkspaceError, state => ({
    ...state,
    error: null
  }))
);
